/**
 * Fabpad Awards — auto-cycling image sequence per award card.
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-fabpad-awards]');
  if (!section) return;

  var intervalMs = 3200;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  section.querySelectorAll('[data-awards-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-awards-slide]');
    var dots = gallery.querySelectorAll('[data-awards-dot]');
    if (slides.length <= 1) return;

    var index = 0;
    var timer = null;

    function setActive(i) {
      index = i;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === i);
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === i);
      });
    }

    function advance() {
      setActive((index + 1) % slides.length);
    }

    function start() {
      stop();
      if (prefersReducedMotion) return;
      timer = window.setInterval(advance, intervalMs);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-awards-dot'), 10);
        if (!isNaN(i)) {
          setActive(i);
          start();
        }
      });
    });

    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    setActive(0);
    start();
  });
})();
